import { AxiosInstance } from './axios.core';
import { API_URL } from './api.base';
import { ListResponseModel, ListRuquestModel } from './models'
import { AxiosRequestConfig } from 'axios'

export const getCertificates = (params: ListRuquestModel): Promise<ListResponseModel<any>> => {
  return AxiosInstance.get(`${API_URL}/certs/list`, { params });
}

export const uploadCertificate = (_params: any): Promise<any> => {
  const params = new FormData();
  for (var key in _params) {
    params.append(key, _params[key]);
  }
  return AxiosInstance.put(
    `${API_URL}/certs/upload`,
    params,
    {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    }
  );
}

export const downloadCertificate = (id: string): Promise<any> => {
  var requestConfig:AxiosRequestConfig = {
    responseType: "blob"
  }
  return AxiosInstance.put(`${API_URL}/certs/download/${id}`, requestConfig);
}

export const deleteCertificate = (id: string): Promise<any> => {
  return AxiosInstance.delete(`${API_URL}/certs/delete/${id}`);
}

export const getAllCertificates = (params: any): Promise<any> => {
  return AxiosInstance.get(`${API_URL}/certs/all`, { params });
}